/*
 * Tally quiz section — postMessage listeners
 * Reads configuration from the wrapper's data-* attributes.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.tallyQuizInit === '1') return;
    root.dataset.tallyQuizInit = '1';

    var allowedOrigins = (root.dataset.allowedOrigins || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var emailPage = parseInt(root.dataset.emailPage, 10);
    if (isNaN(emailPage)) emailPage = -1;
    var redirectUrl = root.dataset.redirectUrl || '/';
    var loaderTextSubmit = root.dataset.loaderTextSubmit || '';

    var loader = root.querySelector('[data-tally-loader]');
    var loaderText = root.querySelector('[data-tally-loader-text]');
    var iframe = root.querySelector('.tally-quiz__iframe');
    var retryButton = root.querySelector('[data-tally-retry]');
    var managedLoad = Boolean(iframe && iframe.dataset && iframe.dataset.src);
    var loaderTextInitial = loaderText ? loaderText.textContent : '';
    var loadTimer = null;
    var loadAttempts = 0;
    var hideTimer = null;
    var iframeReady = false;
    var submissionStarted = false;

    if (iframe) {
      try {
        var formOrigin = new URL(managedLoad ? iframe.dataset.src : iframe.src, window.location.href).origin;
        if (allowedOrigins.indexOf(formOrigin) === -1) allowedOrigins.push(formOrigin);
      } catch (e) { }
    }

    function showLoader(autoHideDelay) {
      if (!loader) return;
      loader.hidden = false;
      void loader.offsetWidth;
      loader.classList.add('is-visible');
      clearTimeout(hideTimer);
      if (typeof autoHideDelay === 'number' && autoHideDelay >= 0) {
        hideTimer = setTimeout(hideLoader, autoHideDelay);
      }
    }

    function hideLoader() {
      if (!loader) return;
      clearTimeout(hideTimer);
      loader.classList.remove('is-visible');
      hideTimer = setTimeout(function () {
        loader.hidden = true;
      }, 250);
    }

    function markIframeReady() {
      if (iframeReady) return;
      iframeReady = true;
      clearTimeout(loadTimer);
      if (retryButton) retryButton.hidden = true;
      if (loaderText) loaderText.textContent = loaderTextInitial;
      hideLoader();
    }

    function startIframe() {
      if (iframeReady || submissionStarted) return;
      clearTimeout(loadTimer);
      loadAttempts++;
      if (retryButton) retryButton.hidden = true;
      if (loaderText) loaderText.textContent = loaderTextInitial;
      showLoader();
      loadTimer = setTimeout(function () {
        if (iframeReady || submissionStarted || root.isConnected === false) return;
        if (loadAttempts < 2) {
          startIframe();
          return;
        }
        if (loaderText) loaderText.textContent = "The form couldn't load. Please try again.";
        if (retryButton) retryButton.hidden = false;
      }, 15000);
      iframe.src = iframe.dataset.src;
    }

    if (iframe && !iframeReady) {
      showLoader();
      iframe.addEventListener('load', function () {
        if (!managedLoad) markIframeReady();
      });
    }

    function parseMessage(event) {
      if (!iframe || event.source !== iframe.contentWindow || allowedOrigins.indexOf(event.origin) === -1) return null;
      var data = event.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return null; }
      }
      if (!data || typeof data !== 'object') return null;
      return data;
    }

    function trackAddToCart(submissionKey) {
      var fbq = window.fbq;
      if (typeof fbq !== 'function' || !submissionKey) return;

      var storageKey = 'tallyQuizFbAddToCart:' + submissionKey;

      try {
        if (window.sessionStorage && window.sessionStorage.getItem(storageKey) === '1') {
          return;
        }
      } catch (e) { }

      fbq('track', 'AddToCart', {
        content_type: 'product'
      });

      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(storageKey, '1');
        }
      } catch (e) { }
    }

    window.addEventListener('message', function (event) {
      var data = parseMessage(event);
      if (!data) return;

      if (!managedLoad || data.event === 'Tally.FormLoaded' || data.event === 'Tally.FormPageView' || data.event === 'Tally.FormSubmitted') {
        markIframeReady();
      }

      if (data.event === 'Tally.FormLoaded') {
        return;
      }

      if (data.event === 'Tally.FormPageView') {
        var pageNumber = (data.payload && data.payload.page != null)
          ? data.payload.page
          : -1;
        if (pageNumber === emailPage) {
          showLoader(1200);
        }
        return;
      }

      if (data.event === 'Tally.FormSubmitted') {
        if (submissionStarted) return;
        var payload = data.payload || {};
        if (!payload.formId || !payload.id) {
          return;
        }
        var fullId = payload.formId + '-' + payload.id;
        var destinationUrl = new URL(redirectUrl, window.location.href);
        destinationUrl.searchParams.set('quizId', 't-' + fullId);
        submissionStarted = true;
        if (loader && loaderText && loaderTextSubmit) {
          loaderText.textContent = loaderTextSubmit;
        }
        showLoader();
        window.location.href = destinationUrl.href;
      }
    });

    applyRetakeQuizId(iframe);

    if (managedLoad) {
      if (retryButton) {
        retryButton.addEventListener('click', function () {
          loadAttempts = 0;
          startIframe();
        });
      }
      startIframe();
    }
  }

  function boot() {
    document.querySelectorAll('[data-tally-quiz-root]').forEach(init);
    document.querySelectorAll('[data-tally-stage-root]').forEach(initStage);
    document.querySelectorAll('[data-ledisa-cover-root]').forEach(initLedisaCover);
  }

  /* ───────────────────────────────────────────────────────────
     Cover → quiz stage transition.
     On click of any [data-ledisa-goal] element inside a stage root
     with data-stage="cover", capture the goal value, append it to
     the iframe URL as ?weight_goal=..., flip stage to "quiz".
     ─────────────────────────────────────────────────────────── */
  function initStage(stageRoot) {
    if (!stageRoot || stageRoot.dataset.tallyStageInit === '1') return;
    stageRoot.dataset.tallyStageInit = '1';

    stageRoot.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ledisa-goal]');
      if (!btn || !stageRoot.contains(btn)) return;
      event.preventDefault();
      var goal = btn.getAttribute('data-ledisa-goal') || '';
      revealQuiz(stageRoot, { weight_goal: goal });
    });
  }

  function revealQuiz(stageRoot, extraParams) {
    if (stageRoot.dataset.stage === 'quiz') return;
    var iframe = stageRoot.querySelector('.tally-quiz__iframe');
    if (iframe && extraParams) {
      try {
        var url = new URL(iframe.src, window.location.href);
        Object.keys(extraParams).forEach(function (k) {
          if (extraParams[k] != null && extraParams[k] !== '') {
            url.searchParams.set(k, extraParams[k]);
          }
        });
        var pass = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
        var qs = new URLSearchParams(window.location.search);
        pass.forEach(function (k) {
          if (qs.has(k)) url.searchParams.set(k, qs.get(k));
        });
        iframe.src = url.toString();
      } catch (e) { /* leave src untouched on failure */ }
    }
    stageRoot.setAttribute('data-stage', 'quiz');
    var cover = stageRoot.querySelector('[data-ledisa-cover-root]');
    if (cover && cover.parentElement) {
      // Drop banner top-padding when cover unmounts
      document.body.classList.remove('has-ledisa-cover');
    }
    if (iframe && typeof iframe.focus === 'function') {
      try { iframe.focus({ preventScroll: true }); } catch (e) { }
    }
    // Scroll back to top so the quiz starts at the iframe origin
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }

  function getRetakeQuizId() {
    var params = new URLSearchParams(window.location.search);
    return params.get('quizId') ||
      (params.get('retake') === '1' ? params.get('retakeQuizId') : '') || '';
  }

  function applyRetakeQuizId(iframe) {
    var quizId = getRetakeQuizId();
    if (!iframe || !quizId) return;

    try {
      var source = iframe.dataset.src || iframe.src;
      var url = new URL(source, window.location.href);
      url.searchParams.delete('retakeQuizId');
      url.searchParams.delete('sourceQuizId');
      url.searchParams.set('quizId', quizId);
      if (iframe.dataset.src) {
        iframe.dataset.src = url.toString();
      } else if (iframe.src !== url.toString()) {
        iframe.src = url.toString();
      }
    } catch (error) {
      console.error('[tally-quiz] Could not pass quizId to the form:', error);
    }
  }

  /* ───────────────────────────────────────────────────────────
     Ledisa cover behaviour: countdown clock to midnight EDT.
     ─────────────────────────────────────────────────────────── */
  function initLedisaCover(coverRoot) {
    if (!coverRoot || coverRoot.dataset.ledisaCoverInit === '1') return;
    coverRoot.dataset.ledisaCoverInit = '1';
    document.body.classList.add('has-ledisa-cover');

    function nowEDT() {
      var opts = { timeZone: 'America/New_York', hour12: false };
      return new Date(new Date().toLocaleString('en-US', opts));
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = nowEDT();
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      var diff = midnight - now;
      if (diff <= 0) diff = 24 * 60 * 60 * 1000;
      var h = pad(Math.floor(diff / 3600000));
      var m = pad(Math.floor((diff % 3600000) / 60000));
      var s = pad(Math.floor((diff % 60000) / 1000));
      coverRoot.querySelectorAll('[data-ledisa-hour]').forEach(function (el) { el.textContent = h; });
      coverRoot.querySelectorAll('[data-ledisa-minute]').forEach(function (el) { el.textContent = m; });
      coverRoot.querySelectorAll('[data-ledisa-seconds]').forEach(function (el) { el.textContent = s; });
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
